import React from 'react'
import {connect} from 'react-redux'

import {
  CONVERSATION_PANE_STATUSES,
  VIEWPORT_TYPES,
  ROLES
} from '../shared/config/constants'

const {ADMIN} = ROLES

import truncateString from '../shared/data/formatters/truncate_string'
import closeConversation from '../shared/data/setters/close_conversation'
import updateConversationStatus from '../shared/data/setters/update_conversation_status'
import toggleIgnoredUser from '../shared/data/setters/toggle_ignored_user'

import ChatHeaderActions from './chat_header_actions'
import CloseButton from './close_button'
import PresenceIndicator from '../shared/presence_indicator'
import SlidingMenu from '../shared/sliding_menu'
import ConversationMenuReportItem from './conversation_menu_report_item'
import UnreadMessageCount from './unread_message_count'

class ConversationUserHeader extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      userIgnored: false
    }

    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleHide = this.toggleHide.bind(this)
    this.toggleIgnore = this.toggleIgnore.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  toggleMenu (e) {
    e.stopPropagation()

    this.setState({isSettingsMenuOpen: !this.state.isSettingsMenuOpen})
  }

  toggleIgnore (e) {
    e.stopPropagation()

    this.props.toggleIgnoredUser(this.props.currentUser.get('uid'), this.props.user.get('uid'), !this.props.isUserIgnored)
  }

  closeConversation () {
    const uid = this.props.currentUserUid || this.props.currentGuestUid
    const conversationId = this.props.conversation.get('conversationId')

    this.props.closeConversation(uid, conversationId, this.props.viewportType)
  }

  toggleConversationHidden () {
    const uid = this.props.currentUserUid || this.props.currentGuestUid
    const conversationId = this.props.conversation.get('conversationId')

    const {OPEN, MINIMIZED} = CONVERSATION_PANE_STATUSES
    let status = this.props.conversation.get('status')
    status = status === OPEN ? MINIMIZED : OPEN

    this.props.updateConversationStatus(uid, conversationId, status, this.props.viewportType)
  }

  toggleHide (e) {
    if (e & e.preventDefault) e.preventDefault()

    if (this.props.viewportType === VIEWPORT_TYPES.PHONE) this.closeConversation()
    else this.toggleConversationHidden()
  }

  onClose (e) {
    if (e && e.stopPropagation) e.stopPropagation()

    this.closeConversation()
  }

  renderUnreadMessageCount () {
    return (
      <UnreadMessageCount
        uid={this.props.currentUserUid}
        shouldShowUnreadMessageCount={this.props.shouldShowUnreadMessageCount}
        conversationId={this.props.conversation.get('conversationId')}/>
    )
  }

  renderIgnore () {
    let ignoreUser = (
      <span>
        <i className='menu-item-icon rc-icon-ignore'></i>
        Ignore user
      </span>
    )

    if (this.props.isUserIgnored) {
      ignoreUser = (
        <span>
          <i className='menu-item-icon rc-icon-confirm'></i>
          Unignore user
        </span>
      )
    }

    return (
      <div className='sliding-menu-item ignore-user' onClick={this.toggleIgnore}>
        {ignoreUser}
      </div>
    )
  }

  renderReport () {
    return (
      <ConversationMenuReportItem
        reportee={this.props.user}
        onReportClicked={this.toggleMenu}/>
    )
  }

  renderSlidingMenu () {
    if (this.props.user && this.props.user.get('role') >= ADMIN) return false

    if (this.props.currentUser) {
      let slidingMenuClasses = 'conversation-menu'
      let isVisible = true

      if (!this.state.isSettingsMenuOpen) {
        slidingMenuClasses += ' hidden'
        isVisible = false
      }

      return (
        <SlidingMenu className={slidingMenuClasses} top={42} isVisible={isVisible}>
          {this.renderIgnore()}
          {this.renderReport()}
        </SlidingMenu>
      )
    }
  }

  renderSettingsButton () {
    if (this.props.user && this.props.user.get('role') >= ADMIN) return false

    if (this.props.currentUser && !this.props.currentUser.get('isBanned')) {
      return (
        <div className='conversation-settings-button' onClick={this.toggleMenu}>
          <i className='rc-icon-settings'></i>
        </div>
      )
    }
  }

  renderUserName () {
    return (
      <a href={this.props.user.get('profileUrl')} target='_blank' onClick={(e) => e.stopPropagation()}>
        {truncateString(this.props.user.get('name'))}
      </a>
    )
  }

  renderChatTitle () {
    if (!this.props.user) return <div className='chat-title'/>

    return (
      <div className='chat-title'>
        {this.renderUserName()}
        <PresenceIndicator user={this.props.user.toJS()} />
        {this.renderUnreadMessageCount()}
      </div>
    )
  }

  render () {
    return (
      <div
        ref='conversationHeader'
        className='conversation-header'
        style={{backgroundColor: this.props.backgroundColor}}
        onClick={this.toggleHide}>
        <div className='conversation-info'>
          {this.renderChatTitle()}
        </div>
        <ChatHeaderActions>
          {this.renderSettingsButton()}
          <CloseButton onClick={this.onClose}/>
        </ChatHeaderActions>
        {this.renderSlidingMenu()}
      </div>
    )
  }
}

ConversationUserHeader.defaultProps = {
  isHidden: false,
  unreadNotificationsCount: 0,
  shouldShowUnreadMessageCount: false
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser'),
    currentUserUid: state.getIn(['currentUser', 'uid']),
    currentGuestUid: state.getIn(['currentGuest', 'uid']),
    user: state.getIn(['users', ownProps.conversation.get('targetId')]),
    viewportType: state.getIn(['viewport', 'type']),
    isUserIgnored: state.getIn(['currentUser', 'ignored', ownProps.conversation.get('targetId')]),
    backgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'headerBackground'])
  }
}

const mapDispatchToProps = () => {
  return {
    closeConversation: closeConversation,
    updateConversationStatus: updateConversationStatus,
    toggleIgnoredUser: toggleIgnoredUser
  }
}

const ConversationUserHeaderContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationUserHeader)

export default ConversationUserHeaderContainer



/** WEBPACK FOOTER **
 ** ./modules/chat_ui/conversation_user_header.js
 **/